module.exports = __webpack_public_path__ + "img/hull-city-logo-icon.cb57bcb8.webp";